import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';
import './CookiePreferencesPage.css';

const DEFAULT_PREFS = {
  essential: true,
  analytics: false,
  marketing: false,
};

export default function CookiePreferencesPage() {
  const [prefs, setPrefs] = useState(DEFAULT_PREFS);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('snapscrap-cookie-prefs');
      if (stored) {
        setPrefs({ ...DEFAULT_PREFS, ...JSON.parse(stored), essential: true });
      }
    } catch {
      // ignore invalid storage
    }
  }, []);

  function toggle(key) {
    if (key === 'essential') return;
    setPrefs((prev) => ({ ...prev, [key]: !prev[key] }));
    setSaved(false);
  }

  function savePrefs() {
    localStorage.setItem('snapscrap-cookie-prefs', JSON.stringify(prefs));
    setSaved(true);
  }

  return (
    <section className="legal-page cookie-page" aria-labelledby="cookies-heading">
      <div className="legal-inner">
        <h1 id="cookies-heading">Cookie Preferences</h1>
        <p className="legal-updated">Last updated: 8 August 2026</p>

        <p>
          We use cookies to run SnapScrap securely and, with your permission, to understand how the
          site is used. Essential cookies are always on.
        </p>

        <div className="cookie-options">
          <label className="cookie-option">
            <span>
              <strong>Essential cookies</strong>
              <small>Required for security, forms, and basic site operation.</small>
            </span>
            <input type="checkbox" checked disabled readOnly />
          </label>

          <label className="cookie-option">
            <span>
              <strong>Analytics cookies</strong>
              <small>Help us understand traffic and improve the experience.</small>
            </span>
            <input
              type="checkbox"
              checked={prefs.analytics}
              onChange={() => toggle('analytics')}
            />
          </label>

          <label className="cookie-option">
            <span>
              <strong>Marketing cookies</strong>
              <small>Used to measure campaigns and relevant service updates.</small>
            </span>
            <input
              type="checkbox"
              checked={prefs.marketing}
              onChange={() => toggle('marketing')}
            />
          </label>
        </div>

        <div className="cookie-actions">
          <button type="button" className="cookie-save" onClick={savePrefs}>
            Save preferences
          </button>
          {saved && <span className="cookie-saved">Preferences saved</span>}
        </div>

        <h2>More information</h2>
        <p>
          See our <Link to="/privacy-policy">Privacy policy</Link> for how we handle personal data,
          or contact us via the <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </section>
  );
}
